export default "__VITE_ASSET__i5GjbG4x__"